import React from "react";
import classes from "./pollutants.module.scss";
import PropTypes from "prop-types";
import SelectInput from "../../UI/selectInput/selectInput";

function Pollutants(props) {
  let inputId, checked;
  return (
    <div className={classes.wrapper}>
      <form className={classes.form_select}>
        <SelectInput
          options={[
            { value: "1", label: "Станція екологічного контролю м.Київ" },
          ]}
        />
      </form>
      <form className={classes.form_radio} action="">
        <div className={classes.block}>
          {Object.keys(props.chemicals).map((key, i) => {
            inputId = `radio${i}`;
            i === 0 ? (checked = true) : (checked = false);
            return (
              <div className={classes.input__block}>
                <input
                  id={inputId}
                  type="radio"
                  name="radio"
                  checked={checked}
                />
                <label for={inputId}>{key}</label>
              </div>
            );
          })}
        </div>
      </form>
    </div>
  );
}

Pollutants.propTypes = {
  chemicals: PropTypes.object.isRequired,
};

export default Pollutants;
